import { render, staticRenderFns } from "./MediaDisplayComponent.vue?vue&type=template&id=89acf6a8"
import script from "./MediaDisplayComponent.vue?vue&type=script&lang=ts"
export * from "./MediaDisplayComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports